import React from "react";
import { Box, Card, CardActions, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CategoryLabel from "./CategoryLabel";

import { Hit } from "react-instantsearch-core";
import CategoryIcon from "./CategoryIcon";
const { DateTime } = require("luxon");

const CARD_IMAGE_HEIGHT = "163px";

const useStyles = makeStyles((theme) => ({
  card: {
    outlineWidth: "2px",
    outlineOffset: "2px",
    height: "100%",
    cursor: "pointer",
    // overflow: "visible",
  },
  link: {
    textDecoration: "none",
    height: "100%",
    display: "block",
    transition: "all .2s ease-in-out",
    "&:hover": {
      transform: "scale(1.02)",
      textDecoration: "none",
    },
    "&:focus": {
      transform: "scale(1.02)",
      textDecoration: "none",
    },
  },
}));

type CustomHitProps = {
  types?: string[];
};

type CustomHit = Hit & CustomHitProps;

interface HitProps {
  hit: CustomHit;
  children?: JSX.Element;
  className?: string;
  headingLevel?: "h2" | "h3" | "h4";
}

const HitCard: React.FunctionComponent<any> = (props): JSX.Element => {
  const classes = useStyles();
  const { hit, headingLevel = "h3" }: HitProps = props;

  //new icon class
  let iconClassName = '';
  if (hit.new_icon) {
    iconClassName = ' new-icon';
  }

  // Date/time for
  const dt = DateTime.fromMillis(hit.create_date);
  const articles = ["Forskning", "Nyheter", "Så gör andra"];
  const isArticle = hit.types && Array.isArray(hit.types) && hit.types.length ? articles.indexOf(hit.types[0]) > -1 : false;

  return (
    <a className="maincard maincard-article" href={hit.url} tabIndex={0}>
      {hit.image_url.length > 0 ? (
        <div className="maincard-image">
          <img src={hit.image_url} alt={hit.image_caption} />
          {hit.new_icon && (
            <div className="maincard-new">NY</div>
          )}
          {hit.types && hit.types.length > 0 && (
            <div className="maincard-article-label">
              <span className="body-3 bold">{hit.types}</span>
            </div>
          )}
        </div>
      ) : (
        <div className="maincard-image no-image"></div>
      )}

      <div className="maincard-content content-is-article">
        <div>
          <h3 className="h4">{hit.title}</h3>
        </div>
        <p>{hit.content_short}</p>

        {hit.categories && Array.isArray(hit.categories) &&
          <div className="maincard-article-meta content-filtering-meta">
            {hit.categories.map((category: string, i: number) => {
              return (
                <>
                  <p className="body-3"><b>{category}</b></p>
                  <div className="divider"></div>
                </>
              )
            })}

            {isArticle && (
              <>
                <p className="body-3"><b>{dt.setLocale("sv").toISODate()}</b></p>
              </>
            )}
          </div>
        }
      </div>
    </a>
  );
};

export default HitCard;
